import { FaInstagram } from 'react-icons/fa';
import styles from './Footer.module.css';

export default function Footer() {

  function LinkToSocialMidia({ link }) {
    window.open(link, '_blank', 'noopener,noreferrer');
  }

  return (
    <div translate="no" className={styles.divfooter}>
      <footer className={styles.footer}>

        {/* TEXTO ESQUERDO */}
        <div className={styles.leftText}>
          <span className={styles.smallLine}></span>

          <p>
            SOFÁS PARA
            <br />
            UMA VIDA MAIS EXTRAORDINÁRIA
          </p>
        </div>


        {/* CENTRO */}
        <div className={styles.centerContent}>

          <FaInstagram
            onClick={() =>
              LinkToSocialMidia({
                link: 'https://www.instagram.com/royal.sofas/'
              })
            }
            className={styles.instagramIcon}
          />

          <p className={styles.copyright}>
            <strong>Royal Sofás</strong> © 2026
          </p>

          <p className={styles.tagline}>
            CONFORTO TRANSFORMA CASAS
          </p>

        </div>


        {/* TEXTO DIREITO */}
        <div className={styles.rightText}>
          <span>
            Viva
            <br />
            bons momentos
          </span>

          <div className={styles.signatureLine}></div>
        </div>

      </footer>
    </div>
  );
}